import { App } from 'vue'
import Element from './Element'
import CertificationBar from './CertificationBar.vue'

const GuijiComponents: any[] = [
  CertificationBar
]

const install = (app: App) => {
  // elementUI组件导入
  Element(app)
  // 项目自定义全局组件
  GuijiComponents.forEach((guiji) => {
    app.component(guiji.name, guiji)
  })
}

export default install
